module.exports = __webpack_public_path__ + "img/10_91.2b123401.png";